module.exports = __webpack_public_path__ + "static/media/caratdropdown.4f204bef.svg";